var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgActiveSessionsIcon = function SvgActiveSessionsIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 41,
    height: 40,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#8E8E93",
    fillRule: "evenodd",
    d: "M3 4a2 2 0 0 0-2 2v20a2 2 0 0 0 2 2h13v2h-1a3 3 0 0 0-3 3v3h14v-3a3 3 0 0 0-3-3h-.982v-.012L22.006 28H23a1 1 0 1 0 0-2h-3.006L20 27.006 20.018 30H18v-4H3V6h32v3a1 1 0 1 0 2 0V6a2 2 0 0 0-2-2zm15 28h-3a1 1 0 0 0-1 1v1h10v-1a1 1 0 0 0-1-1z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#8E8E93",
    fillRule: "evenodd",
    d: "M32.5 14c3.188 0 5.945 2.653 5.945 5.639 0 .748-.24 1.666-.754 2.77-.508 1.095-1.227 2.257-2.061 3.474-.563.82-1.143 1.616-1.727 2.418q-.438.6-.879 1.213-.263.367-.523.738a75 75 0 0 0-.524-.738q-.44-.613-.88-1.213a107 107 0 0 1-1.726-2.418c-.835-1.217-1.554-2.379-2.062-3.474-.513-1.104-.753-2.022-.753-2.77 0-2.985 2.757-5.639 5.945-5.639zm2.998 15.51a87 87 0 0 0-1.808 2.542A21 21 0 0 0 32.5 34a21 21 0 0 0-1.189-1.948 89 89 0 0 0-1.808-2.543c-2.359-3.238-4.947-6.792-4.947-9.87 0-4.19 3.755-7.639 7.945-7.639s7.944 3.45 7.944 7.639c0 3.078-2.589 6.632-4.947 9.87zm-.72-9.566a2.278 2.278 0 1 1-4.556 0 2.278 2.278 0 0 1 4.556 0m2 0a4.278 4.278 0 1 1-8.556 0 4.278 4.278 0 0 1 8.556 0",
    clipRule: "evenodd"
  })));
};
export default SvgActiveSessionsIcon;